import { LangEnum } from '@/constants/locales'

export const localeSmartBannerPhoneMap = {
  [LangEnum.THAI]: '/images/smart-banner-phone-th.png',
  [LangEnum.ENG]: '/images/smart-banner-phone-en.png',
  [LangEnum.TW]: '/images/smart-banner-phone-zh.png',
  [LangEnum.HK]: '/images/smart-banner-phone-zh.png',
}
